import React, { useState, useEffect } from 'react';
import Modal from '../../modal';
import { Cheveron, Close, Search } from '../../../constants';

interface Option {
  id: string | number;
  label: string;
}

interface DropdownSelectProps {
  id?: string;
  label: string;
  options: Option[];
  selected: Option[];
  setSelected: (options: Option[]) => void;
  placeholder: string;
  hasError?: boolean;
  disabled?: boolean;
  displayValue?: string;
  showSelectAll?: boolean;
  description?: string;
}

const DropdownSelect: React.FC<DropdownSelectProps> = ({ id, label, options, selected, setSelected, placeholder, hasError, disabled, displayValue, showSelectAll = true, description }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [search, setSearch] = useState<string>('');
  const [selectAllChecked, setSelectAllChecked] = useState<boolean>(false);

  const isRadio = (label === 'District' || label === 'Select Retailer/Distributor');

  const toggleOption = (option: Option) => {
    if (disabled) return;

    if (isRadio) {
      setSelected([option]);
    } else {
      const exists = selected.find(o => o.id === option.id);
      if (exists) {
        setSelected(selected.filter(o => o.id !== option.id));
      } else {
        setSelected([...selected, option]);
      }
    }
  };

  const handleSelectAll = () => {
    if (selectAllChecked) {
      setSelected([]);
      setSelectAllChecked(false);
    } else {
      setSelected([...options]);
      setSelectAllChecked(true);
    }
  };

  useEffect(() => {
    setSelectAllChecked(options.length === selected.length);
  }, [selected, options.length]);

  const filteredOptions = options.filter(o =>
    o.label.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="form-group" style={{ width: label == 'District' ? '50%' : '100%' }}>
      {label !== 'District' && <label style={{ fontSize: 14, display: 'block', marginBottom: 10, fontWeight: 600 }}>{label}<mark style={{ background: 'transparent', color: 'red' }}>*</mark></label>}

      <div
        className={`product-select-field ${hasError ? 'error-border' : ''} ${disabled ? 'disabled' : ''}`}
        style={{ background: disabled ? 'rgba(239, 239, 239, 0.3)' : '#fff', position: 'relative' }}
        onClick={() => {
          if (!disabled) {
            setIsModalOpen(true);
          }
        }}
      >
        {displayValue
          ? displayValue
          : selected.length > 0
            ? selected.map(s => s.label).join(', ')
            : placeholder}
        <img src={Cheveron} style={{ position: 'absolute', right: 0 }} width={20} height={20} alt="" />
      </div>

      <Modal isOpen={isModalOpen} onClose={() => { setIsModalOpen(false); setSearch(''); }}>
        <div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3>{label}</h3>
            <img src={Close} style={{ height: 25, width: 25, cursor: 'pointer' }} alt="" onClick={() => { setIsModalOpen(false); setSearch(''); }} />
          </div>
          {description && <span style={{ display: 'block', marginBottom: 20, fontSize: 14 }}>{description}</span>}
          {id === 'select-your-distributor' && <span style={{
            color: 'rgba(0, 0, 0, 0.60)',
            fontSize: 16,
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: 0.15
          }}>{options.length} Distributors in your area.</span>}
          {!isRadio && showSelectAll &&
            <div
              style={{
                position: 'sticky',
                top: 0,
                background: 'white',
                zIndex: 1,
                paddingBottom: 10,
                marginBottom: 10,
                borderBottom: '1px solid #ccc'
              }}>
              <label style={{ fontSize: 12 }}>
                <input type="checkbox" checked={selectAllChecked} onChange={handleSelectAll} style={{ marginRight: 5 }} /> Select All
              </label>
            </div>}
          {showSelectAll && <span>{selected.length} Selected</span>}

          <input
            type="text"
            className="search-input"
            placeholder={`Search for ${label}`}
            value={search}
            style={{
              backgroundImage: `url(${Search})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: '3px 10px',
              backgroundSize: 21
            }}
            onChange={(e) => setSearch(e.target.value)}
          />
          {filteredOptions.length > 0 ? <div className="options-list">
            {filteredOptions.map(option => (
              <div
                key={option.id}
                className="option-item"
                onClick={() => toggleOption(option)}
              >
                <div>
                  <span style={{ textTransform: 'capitalize' }}>{option.label && option.label.toLowerCase()}</span>
                  {id === 'select-your-distributor' && <span style={{color:'rgba(0, 0, 0, 0.60)', fontSize:14, display:'block', lineHeight:'20px'}}>{option.id}</span>}
                </div>
                <input
                  type={isRadio ? 'radio' : 'checkbox'}
                  name={isRadio ? 'district' : undefined}
                  checked={selected.some(o => o.id === option.id)}
                  onChange={() => { }}
                />
              </div>
            ))}
          </div> : <div style={{

            height: 200,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: 14

          }}>
            No Matching result found
          </div>}


          <button className="confirm-btn" onClick={() => { setIsModalOpen(false); setSearch(''); }}>Confirm</button>
        </div>
      </Modal>
    </div>
  );
};

export default DropdownSelect;